import Vue from 'vue'

Vue.prototype.$MONTHS4_TABLE = [
  { name: '4月', value: 4 },
  { name: '5月', value: 5 },
  { name: '6月', value: 6 },
  { name: '7月', value: 7 },
  { name: '8月', value: 8 },
  { name: '9月', value: 9 },
  { name: '10月', value: 10 },
  { name: '11月', value: 11 },
  { name: '12月', value: 12 },
  { name: '1月', value: 1 },
  { name: '2月', value: 2 },
  { name: '3月', value: 3 }
]

Vue.prototype.$MONTHS13_TABLE = [
  { name: '毎月', value: 0 },
  { name: '（1）月', value: 1 },
  { name: '（2）月', value: 2 },
  { name: '（3）月', value: 3 },
  { name: '（4）月', value: 4 },
  { name: '（5）月', value: 5 },
  { name: '（6）月', value: 6 },
  { name: '（7）月', value: 7 },
  { name: '（8）月', value: 8 },
  { name: '（9）月', value: 9 },
  { name: '（10）月', value: 10 },
  { name: '（11）月', value: 11 },
  { name: '（12）月', value: 12 },
  { name: '（13）月', value: 13 }
]

Vue.prototype.$MONTH = [ '04', '05', '06', '07', '08', '09', '10', '11', '12', '01', '02', '03' ]
Vue.prototype.$MONTHS1 = [ '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月' ]
Vue.prototype.$MONTH1 = [ '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12' ]
Vue.prototype.$WEEK = [ '日', '月', '火', '水', '木', '金', '土' ]

Vue.prototype.$WEEK_TABLE = [
  { name: '第1週', value: 1 },
  { name: '第2週', value: 2 },
  { name: '第3週', value: 3 },
  { name: '第4週', value: 4 }
]

Vue.prototype.$WEEK_ZONE_TABLE = [
  { name: 'A', value: 1 },
  { name: 'B', value: 2 },
  { name: 'C', value: 3 },
  { name: 'D', value: 4 }
]

Vue.prototype.$DESCRIPTIONS_ITEMS = [
  { key: 1, name: '教室運営', color: 'deep-purple', rgb: '#673AB7', light: '#D1C4E9', dark: '#311B92', value: true },
  { key: 2, name: '販売促進', color: 'brown', rgb: '#795548', light: '#D7CCC8', dark: '#3E2723', value: true },
  { key: 3, name: '人事', color: 'teal', rgb: '#009688', light: '#B2DFDB', dark: '#004D40', value: true },
  { key: 4, name: '教務', color: 'blue-grey', rgb: '#607D8B', light: '#CFD8DC', dark: '#263238', value: true }
]
Vue.prototype.$COLOR_LIGHT = 1
Vue.prototype.$COLOR_DARK = 2

Vue.prototype.$ACTION_TABLE = [
  { key: 1, name: '準備', value: 'ready' },
  { key: 2, name: '作成', value: 'create' },
  { key: 3, name: '検討', value: 'think' },
  { key: 4, name: '回収', value: 'collect' },
  { key: 5, name: '集計', value: 'aggregate' },
  { key: 6, name: '連絡', value: 'inform' },
  { key: 7, name: '依頼', value: 'request' },
  { key: 8, name: '確認', value: 'check' },
  { key: 9, name: '報告', value: 'report' },
  { key: 10, name: '投函', value: 'post' },
  { key: 11, name: '実施', value: 'execute' },
  { key: 12, name: '対応', value: 'think' },
  { key: 13, name: '会議', value: 'meeting' },
  { key: 14, name: '掲示', value: 'display' },
  { key: 15, name: '配布', value: 'handout' },
  { key: 16, name: '集客', value: 'attract' },
  { key: 17, name: '決定', value: 'decide' },
  { key: 18, name: '出題', value: 'question' },
  { key: 19, name: '面談', value: 'interview' },
  { key: 20, name: '告知', value: 'notice' }
]

Vue.prototype.$TASK_STATUS = [
  { key: 1, name: '着手前', icon: 'mdi-bell-outline' },
  { key: 2, name: '対応中', icon: 'mdi-run' },
  { key: 3, name: '保留', icon: 'mdi-pause-circle-outline' },
  { key: 4, name: '中止', icon: 'mdi-cancel' },
  { key: 5, name: '完了', icon: 'mdi-bullseye-arrow' }
]

Vue.prototype.$GENDERS = [
  { key: 1, name: '無回答' },
  { key: 2, name: '女性' },
  { key: 3, name: '男性' },
  { key: 4, name: 'その他' }
]

Vue.prototype.$PERSONALITY_COLORS = {
  null: 'primary',
  personality: 'indigo',
  study: 'error',
  hobby: 'orange',
  food: 'cyan',
  sport: 'deep-purple',
  dream: 'pink',
  other: 'green'
}

Vue.prototype.$PERSONALITY_ICONS = {
  null: 'mdi-emoticon-outline',
  personality: 'person',
  study: 'mdi-school',
  hobby: 'mdi-book-open-page-variant',
  food: 'mdi-food',
  sport: 'accessibility',
  dream: 'mdi-chart-bubble',
  other: 'star'
}

Vue.prototype.$GRADES = [
  { key: 1, name: '小学1年生' },
  { key: 2, name: '小学2年生' },
  { key: 3, name: '小学3年生' },
  { key: 4, name: '小学4年生' },
  { key: 5, name: '小学5年生' },
  { key: 6, name: '小学6年生' },
  { key: 7, name: '中学1年生' },
  { key: 8, name: '中学2年生' },
  { key: 9, name: '中学3年生' },
  { key: 10, name: '高校1年生' },
  { key: 11, name: '高校2年生' },
  { key: 12, name: '高校3年生' },
  { key: 13, name: '既卒' }
]

Vue.prototype.$PRIVILEGES = [
  { key: 0, role: 'admin', name: '管理者', icon: 'mdi-shield-account' },
  { key: 1, role: 'owner', name: '塾長', icon: 'mdi-school' },
  { key: 2, role: 'chief', name: '室長', icon: 'mdi-account-tie' },
  { key: 3, role: 'teacher', name: '講師', icon: 'mdi-clipboard-account' }
  // { key: 4, role: 'user', name: '生徒', icon: 'mdi-account' }
]

Vue.prototype.$PRIVILEGES_OWNER = [
  { key: 1, role: 'owner', name: '塾長', icon: 'mdi-school' },
  { key: 2, role: 'chief', name: '室長', icon: 'mdi-account-tie' },
  { key: 3, role: 'teacher', name: '講師', icon: 'mdi-clipboard-account' }
  // { key: 4, role: 'user', name: '生徒', icon: 'mdi-account' }
]

Vue.prototype.$PRIVILEGES_TABLE = {
  'admin': 0,
  'owner': 1,
  'chief': 2,
  'teacher': 3,
  'user': 4
}

Vue.prototype.$STATUS = [
  { key: 1, name: '問合せ' },
  { key: 2, name: '保護者面談' },
  { key: 3, name: '体験授業' },
  { key: 4, name: '提案' },
  { key: 5, name: '入塾' },
  { key: 6, name: '在籍' },
  { key: 7, name: '退塾' },
  { key: 8, name: '逸失' }
]

Vue.prototype.$STATUS_INQUIRY = 1
Vue.prototype.$STATUS_ADMISSION = 6
Vue.prototype.$STATUS_GRADUATION = 7
Vue.prototype.$STATUS_LOSE = 8

Vue.prototype.$ACTIONS = [
  { key: 1, name: 'DTS' }, // 9
  { key: 2, name: '生徒面談' }, // 10
  { key: 3, name: '保護者面談' }, // 11
  { key: 4, name: 'YCS' }, // 12
  { key: 5, name: '約束' }, // 13
  { key: 6, name: '退塾' }, // 14
  { key: 7, name: 'その他' } // 15
]

Vue.prototype.$YCSS = [
  { key: 1, name: '◎' },
  { key: 2, name: '◯' },
  { key: 3, name: '△' },
  { key: 4, name: 'Ｘ' }
]

Vue.prototype.$NOTICE_TYPE = [
  { key: 1, name: 'コミュニティ会', color: 'primary', icon: 'mdi-school', admin: false },
  { key: 2, name: '情報共有', color: 'warning', icon: 'mdi-information', admin: false },
  { key: 3, name: 'メインテナンス', color: 'error', icon: 'mdi-alert', admin: true }
]

Vue.prototype.$SHARES = [
  { key: 'public', name: '塾外' },
  { key: 'local', name: '塾内' },
  { key: 'restrict', name: '塾内（講師を除く）' }
]

Vue.prototype.$SCOPES = [
  { key: 'public', name: '公開' },
  { key: 'local', name: '塾内' }
]

Vue.prototype.$VIDEO_ID = [
  { key: 'folder', name: 'フォルダ' },
  { key: 'video', name: '動画' }
]

Vue.prototype.$MEDIAS = [
  { key: 1, name: '折込チラシ' },
  { key: 2, name: '通りがかり' },
  { key: 3, name: '兄弟' },
  { key: 4, name: '姉妹' },
  { key: 5, name: '紹介' },
  { key: 6, name: 'WEB' },
  { key: 7, name: 'その他' }
]

Vue.prototype.$MIMEICON = {
  'application/vnd.google-apps.folder': 'mdi-folder',
  'application/vnd.google-apps.document': 'mdi-file-document-box',
  'application/vnd.google-apps.spreadsheet': 'mdi-google-spreadsheet',
  'application/vnd.google-apps.presentation': 'mdi-file-presentation-box',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'mdi-file-excel-box',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'mdi-file-word-box',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'mdi-file-powerpoint-box',
  'video/x-youtube': 'mdi-youtube',
  'video/quicktime': 'mdi-movie',
  'application/pdf': 'mdi-file-pdf-box',
  'image/png': 'mdi-image',
  'image/jpeg': 'mdi-image'
}

var apiKey = null
var clientId = null
var discoveryDocs = [ 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest' ]
var scope = 'https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email'

switch (location.hostname) {
  case 'realte.site':
    apiKey = process.env.VUE_APP_REALTE_PROD_OAUTH2_API_KEY
    clientId = process.env.VUE_APP_REALTE_PROD_OAUTH2_CLIENTID
    break
  case 'dev.realte.site':
    apiKey = process.env.VUE_APP_REALTE_DEV_OAUTH2_API_KEY
    clientId = process.env.VUE_APP_REALTE_DEV_OAUTH2_CLIENTID
    break
  case 'localhost':
    apiKey = process.env.VUE_APP_REALTE_DEV_OAUTH2_API_KEY
    clientId = process.env.VUE_APP_REALTE_DEV_OAUTH2_CLIENTID
    break
  case 'jibun.vision':
    apiKey = process.env.VUE_APP_GV_PROD_OAUTH2_API_KEY
    clientId = process.env.VUE_APP_GV_PROD_OAUTH2_CLIENTID
    break
  case 'dev.jibun.vision':
    apiKey = process.env.VUE_APP_GV_DEV_OAUTH2_API_KEY
    clientId = process.env.VUE_APP_GV_DEV_OAUTH2_CLIENTID
    break
  // case 'localhost':
  //   apiKey = process.env.VUE_APP_GV_DEV_OAUTH2_API_KEY
  //   clientId = process.env.VUE_APP_GV_DEV_OAUTH2_CLIENTID
  //   break
}

export const googleKeys = {
  apiKey: apiKey,
  clientId: clientId,
  discoveryDocs: discoveryDocs,
  scope: scope
}
